import ReserveVue from '@/views/unbindMember/reservation/reservation.vue';

const basePath = '/unbind-member/reservation';
const role = 'unbindMember'; // 角色身份

export const UN_M_RESERVATION_INDEX = 'un-m-reservation-index';
export const UN_M_RESERVATION_CREATE = 'un-m-reservation-create';
export const UN_M_RESERVATION_SUCCESS = 'un-m-reservation-success';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ReserveVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: UN_M_RESERVATION_INDEX,
      component: () => import(
        /* webpackChunkName: "reservation" */
        `@/views/${role}/reservation/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/create`,
      name: UN_M_RESERVATION_CREATE,
      component: () => import(
        /* webpackChunkName: "create" */
        `@/views/${role}/reservation/create.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/success`,
      name: UN_M_RESERVATION_SUCCESS,
      component: () => import(
        /* webpackChunkName: "success" */
        `@/views/${role}/reservation/success.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
